import { render, staticRenderFns } from "./SendOrder.vue?vue&type=template&id=83b01eac"
import script from "./SendOrder.vue?vue&type=script&lang=js"
export * from "./SendOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VBtn,
  VCard,
  VDataTable,
  VFlex,
  VLayout,
  VSelect,
  VTextField,
})
